export default {"src":"/_next/static/media/publish.0256950d.svg","height":284,"width":284};